export const GET_EMPLOYEE = `/v2/employees`;
export const EMPLOYEE_BY_ID = (id, type) => `/v2/${type}/${id}`;
export const EMPLOYEES = (type) => `/v2/${type}`;
export const founders = (type) => `/v2/employees/active/${type}`;
export const lastFounder = (type) => `/v2/employees/inactive/${type}`;
export const UP_DATE = (id) => `/v2/employees/${id}`;
export const VOLUNTEER = "/v2/volunteers";
export const UPDATE_VOLUNTEER = (id) => `/v2/volunteers/${id}`;
export const GET_ROULS = (id) => `/v2/memberships/${id}`;
export const CREATE_ROULS = `/v2/memberships`;
export const generalInfo = `/v2/org-information`;
export const GENERAL_INFO_BY_ID = (id) => `/v2/org-information/${id}`;

// export const UPDATE_ROULS = (id) => `/v2/memberships/${id}`;
